var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15138 7.33331H11.8494C12.424 7.33331 12.7294 6.65332 12.3474 6.22332L8.49871 1.89331C8.43628 1.82285 8.35961 1.76644 8.27377 1.7278C8.18792 1.68917 8.09485 1.66919 8.00071 1.66919C7.90657 1.66919 7.8135 1.68917 7.72766 1.7278C7.64181 1.76644 7.56514 1.82285 7.50271 1.89331L3.65271 6.22332C3.27071 6.65332 3.57604 7.33331 4.15138 7.33331ZM7.50204 14.106C7.56447 14.1764 7.64114 14.2329 7.72699 14.2715C7.81284 14.3101 7.9059 14.3301 8.00004 14.3301C8.09418 14.3301 8.18725 14.3101 8.2731 14.2715C8.35895 14.2329 8.43562 14.1764 8.49804 14.106L12.3467 9.77598C12.7294 9.34665 12.424 8.66665 11.8487 8.66665H4.15138C3.57671 8.66665 3.27138 9.34665 3.65338 9.77665L7.50204 14.106Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrows);
export default __webpack_public_path__ + "static/media/sortArrows.9ff8e9a2f10315d8d30bdf3d1c789dc2.svg";
export { ForwardRef as ReactComponent };